export {TestingOptionsConnected as TestingOptions} from './TestingOptions.connect';
